<!-- Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com -->
<!-- See license file. -->
<script setup lang="ts">
import { computed, inject } from "vue";
import DossierList from "@/components/dossier/DossierList.vue";
import { filesKey } from "@/logic/provide";
import NavigationManager from "@/components/navigation/NavigationManager.vue";
import Navigation from "@/components/navigation/Navigation.vue";
import type { CaseEdit } from "@/types";
import { useRoute } from "vue-router";
import { isArray } from "lodash";

const cases = inject(filesKey);
const props = defineProps<{
  creationTemplate?: CaseEdit;
}>();
const route = useRoute();

const requester = computed(() => route.query.requester);

const creationTemplate = computed(() => {
  if (requester.value) {
    if (isArray(requester.value)) {
      return {
        sources: [
          ...requester.value.map((a) => ({ name: "", type: null, id: a })),
        ],
      };
    } else {
      return { sources: [{ id: requester.value, type: null, name: "" }] };
    }
  } else {
    return props.creationTemplate;
  }
});
</script>

<template>
  <div v-if="!cases || cases.list.length === 0"></div>
  <NavigationManager>
    <Navigation navKey="Base des dossiers">
      <DossierList :allowCreation="true" :creationTemplate="creationTemplate" />
    </Navigation>
  </NavigationManager>
</template>

<style></style>
